document.addEventListener("DOMContentLoaded", function () {
  // Get the 'question' parameter from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const questions = urlParams.get("question");

  const defaultQuestions = [
    "What Is Microdosing On Love?",
    "What Is Blockchain?",
    "What Is Valuable Intelligence?",
  ]; // Set default questions

  // Split the questions into an array if needed
  const questionArray = questions ? questions.split(",") : defaultQuestions;

  // Set the questions in the respective tab blocks
  document.getElementById("tab1").querySelector("span").innerText =
    questionArray[0] || defaultQuestions[0];
  document.getElementById("tab2").querySelector("span").innerText =
    questionArray[1] || defaultQuestions[1];
  document.getElementById("tab3").querySelector("span").innerText =
    questionArray[2] || defaultQuestions[2];

  // Store the question in a cookie for future visits
  document.cookie = `question=${
    questions || defaultQuestions.join(",")
  }; path=/`;
});

// Clear the 'question' cookie when the user navigates away
window.addEventListener("beforeunload", function () {
  document.cookie = "question=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
});

// document.addEventListener("DOMContentLoaded", function () {
//   // Get the 'question' parameter from the URL
//   const urlParams = new URLSearchParams(window.location.search);
//   const question = urlParams.get("question");
//   const defaultQuestion = "Default Question"; // Set your default question here

//   // Set the question in the tab block if it exists, otherwise use the default
//   if (question) {
//     document.getElementById("tab1").querySelector("span").innerText = question;
//   } else {
//     document.getElementById("tab1").querySelector("span").innerText =
//       defaultQuestion;
//   }

//   // Store the question in a cookie
//   document.cookie = `question=${question || defaultQuestion}; path=/`;
// });

// window.addEventListener("beforeunload", function () {
//   document.cookie = "question=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
// });

/************** review slider ********************/

// $(document).ready(function () {
//   $(".review_slider").slick({
//     slidesToShow: 3,
//     infinite: false,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//   });
// });
